module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/administracion/categorias-gastos/categorias-gastos.component.scss
// module id = ./src/app/administracion/categorias-gastos/categorias-gastos.component.scss
// module chunks = main